import { Pipe, PipeTransform } from "@angular/core";

/**
 * If pipe value is less than the given value, return "<" + value.
 */
@Pipe({
	name: "number_less_than",
	standalone: false
})
export class NumberLessThanPipe implements PipeTransform {
	public transform(value: string | number, lessThanValue: number): string | number {
		if (+value < lessThanValue) {
			return "<" + lessThanValue;
		}

		return value;
	}
}

@Pipe({
	name: "more_than_two_decimals",
	standalone: false
})
export class NumberMoreThanTwoDecimalsPipe implements PipeTransform {
	public transform(value: string | number): boolean {
		const decimals = value.toString().split(".")[1];
		return +decimals.length > 2;
	}
}
